import { render } from "./AppInputLocation.vue?vue&type=template&id=aea977dc&ts=true"
import script from "./AppInputLocation.vue?vue&type=script&lang=ts"
export * from "./AppInputLocation.vue?vue&type=script&lang=ts"

import "./AppInputLocation.vue?vue&type=style&index=0&id=aea977dc&lang=postcss"

import exportComponent from "/builds/wVusKqw4/0/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__